<template>
    <div class="navbar">
        <router-link to="/production/target" :class="{active : navbar === 2}">
            <Icon type="md-filing" size="18"/>&nbsp;{{$t('a_pdTarget')}}
        </router-link>
        <!-- <router-link to="/production/cost" :class="{active : navbar === 3}" v-if="$store.state.user.rank==1"> -->
        <router-link to="/production/cost" :class="{active : navbar === 3}" v-if="false">
            <Icon type="md-analytics" size="18"/>&nbsp;{{$t('a_costAnalysis')}}
        </router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {
        navbar() {
            return this.$store.state.navbar;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/production/components/navbar.vue